'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DrawerHeader", {
    enumerable: true,
    get: function() {
        return DrawerHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useDrawerHeader = require("./useDrawerHeader");
const _renderDrawerHeader = require("./renderDrawerHeader");
const _useDrawerHeaderStylesstyles = require("./useDrawerHeaderStyles.styles");
const DrawerHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDrawerHeader.useDrawerHeader_unstable)(props, ref);
    (0, _useDrawerHeaderStylesstyles.useDrawerHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerHeaderStyles_unstable')(state);
    return (0, _renderDrawerHeader.renderDrawerHeader_unstable)(state);
});
DrawerHeader.displayName = 'DrawerHeader';
